/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { FC } from 'react'
import LayoutDefault from '@/components/layouts/Layout'
import SectionHeaderService from '@/components/modules/SectionHeaderService'
import TitleShadow from '@/components/modules/TitleShadow'
import Benefit from '@/components/modules/Benefit'
import ListBullet from '@/components/modules/ListBullet'
import ServiceItem from '@/components/modules/ServiceItem'
import PortfolioItem from '@/components/modules/PortfolioItem'
import WarrantyItem from '@/components/modules/WarrantyItem'
import ServiceGetInTouch from '@/components/modules/ServiceGetInTouch'
import Button from '@/components/elements/Button'
import ImgResponsive from '@/components/elements/ImgResponsive'
import Router from 'next/router'
import { FaArrowRight } from 'react-icons/fa'
import Link from 'next/link'

const ServicePage: FC = () => {
  return (
    <LayoutDefault>
      <SectionHeaderService
        bgColors='#1990FF'
        bgImage='/images/service/Twin_Service_mobile.webp'
        bgImageMd='/images/service/Twin_Service_mobile.webp'
        bgImageSm='/images/service/Twin_Service_mobile.webp'
        title={<>&quot;เปลี่ยนธุรกิจของคุณให้เฉิดฉายบนโลกดิจิทัล&quot;</>}
        description='"Transforming Your Business into Digital Reality"'
        bgImageWidth={1214}
        bgImageHeight={534}
        btnText='เริ่มโปรเจกต์'
        onClick={() => Router.push('/contact-service')}
        prologue='แอปพลิเคชั่น'
        colorPrologue='rgba(0,0,0,.08)'
        titleShadow='พัฒนาแอปพลิเคชั่นมือถือ'
        colorTitleShadow='#000000'
        align='center'
        content={
          <>
            <p className='text-center'>
              หากคุณต้องการเปลี่ยนการให้บริการของคุณไปสู่โลกดิจิทัล
              ซึ่งนอกจากการสร้างเว็บไซต์ที่มีประสิทธิภาพแล้ว แอปพลิเคชันมือถือ (Mobile Application)
              ก็เป็นอีกหนึ่งทางเลือกที่น่าสนใจที่จะช่วยเพิ่มศักยภาพในการให้บริการของคุณ
              ช่วยเพิ่มความสะดวกสบายในการใช้บริการให้กับลูกค้า และเป็นการเปิดประสบการณ์ใหม่ ๆ
              ให้กับลูกค้าของคุณทำให้ธุรกิจมีความน่าเชื่อถือมากขึ้นอีกด้วย
            </p>
            <p className='text-center'>
              การพัฒนาแอปพลิเคชันมือถือ (Mobile Application Development)
              จำเป็นต้องใช้ทีมออกแบบและทีมพัฒนาที่มีทักษะ มีประสบการณ์ และความเชี่ยวชาญในการพัฒนาสูง
              รวมถึงจำเป็นต้องมีความรู้ความเข้าใจในธุรกิจหรือบริการของลูกค้าเป็นอย่างดี
              ให้ความสำคัญในการทำงานร่วมกันอย่างมีประสิทธิภาพ
              การสื่อสารที่กระชับและชัดเจนระหว่างทีมพัฒนาและลูกค้า
            </p>
            <p className='text-center'>
              Twin Synergy คือทีมพัฒนาแอปพลิเคชันมือถือที่มีประสบการณ์และมีความเชี่ยวชาญสูง
              เราสามารถแนะนำเทคโนโลยีและโซลูชั่นที่ดีที่สุดในการพัฒนาแอปพลิเคชั่นมือถือให้เหมาะสมกับความต้องการการของลูกค้าอย่างเต็มที่
              การประเมินราคาและระยะเวลาของโครงการที่แม่นยำ
              โดยเราให้ความสำคัญในการบริหารโครงการอย่างมีประสิทธิภาพและโปร่งใส
              รวมถึงมุ่งเน้นในการดูแลและการให้บริการลูกค้า โดยยึดเอาความพึงพอใจของลูกค้าเป็นหลัก
            </p>
            <div className='text-center'>
              <Button
                htmlType='button'
                className='btn-neutral'
                onClick={() => Router.push('/contact-service')}
              >
                ปรึกษาผู้เชี่ยวชาญ
              </Button>
            </div>
          </>
        }
      />
      <div className='pb-24 lg:pb-0 xl:pt-44'>
        <div className='container mx-auto space-y-8 px-4 lg:pt-44 xl:pt-0'>
          <TitleShadow
            prologue='คุณสมบัติที่สำคัญ'
            colorPrologue='rgba(0,0,0,.08)'
            title={
              <>
                คุณสมบัติที่สำคัญในการให้บริการ
                <br />
                พัฒนาเว็บไซต์ของเรา
              </>
            }
            colorTitle='#000000'
            align='center'
          />
          <div className='grid grid-cols-1 gap-8 lg:grid-cols-2'>
            <Benefit
              className='border-none text-content-base'
              title={<>ที่ลูกค้ากำหนดเอง</>}
              prologue='01.'
              subtitle='โซลูชัน'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>
                  เราเข้าใจว่าธุรกิจแต่ละธุรกิจมีเอกลักษณ์เป็นของตนเอง
                  มีการให้บริการและการจัดการกับปัญหาที่แตกต่างกัน
                  นั่นคือเหตุผลที่เรานำเสนอโซลูชั่นแอปพลิเคชั่นมือถือที่สามารถปรับให้เหมาะกับธุรกิจหรือบริการของลูกค้าได้ด้วยตัวลูกค้าเอง
                  โดยทีมพัฒนาจำเป็นต้องทำงานกับลูกค้าอย่างใกล้ชิดเพื่อทำความเข้าใจกับความต้องการที่เฉพาะเจาะจง
                  การสร้างแบรนด์ และกลุ่มเป้าหมายทางธุรกิจของคุณ
                  เพื่อให้มั่นใจว่าแอปพลิเคชั่นมือถือของคุณตรงตามเป้าหมายของธุรกิจ
                </p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={<>การใช้งานที่ราบรื่น</>}
              prologue='02.'
              subtitle='ประสบการณ์'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>
                  เราให้ความสำคัญในการพัฒนาแอปพลิเคชั่นมือที่มีประสิทธิภาพสูงและคำนึงถึงประสบการณ์ของผู้ใช้งานเป็นหลัก
                  มีดีไซน์ที่สวยงาม ดึงดูด และใช้งานง่าย (User Friendly)
                  ไปจนถึงความเร็วและความเสถียรของแอป
                  เพื่อให้มั่นใจว่าการพัฒนาแอปพลิเคชั่นมือถือครั้งนี้สามารถมอบความสุขให้กับลูกค้าและนำให้ลูกค้ากลับมาใช้ซ้ำได้
                </p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <div className='lg:col-span-2'>
              <ImgResponsive
                src='/images/service/middle_sevice_mobile.webp'
                alt='Twin Synergy service'
                sourceImgSm='/images/service/middle_sevice_mobile.webp'
                sourceImgMd='/images/service/middle_sevice_mobile.webp'
                loadingLazy
                className='mx-auto'
              />
            </div>
            <Benefit
              className='border-none text-content-base'
              title={<>และฟังก์ชันที่เจ๋ง</>}
              prologue='03.'
              subtitle='ฟีเจอร์'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>
                  ยกตัวอย่าง เช่น มีการแจ้งเตือนแบบเรียลไทม์ มีระบบ GPS
                  การเชื่อมต่อกับโซเชียลมิเดียต่าง ๆ เป็นต้น ซึ่งฟีเจอร์เหล่านี้
                  จะช่วยเพิ่มความน่าสนใจและการมีส่วนร่วมให้กับผู้ใช้งานและจะช่วยส่งเสริมการเติบโตทางธุรกิจ
                </p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={<>และความน่าเชื่อถือ</>}
              prologue='04.'
              subtitle='ความปลอดภัย'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>
                  เป็นสิ่งที่สำคัญอย่างยิ่งสำหรับความปลอดภัยและความน่าเชื่อถือของแอปพลิเคชั่นมือถือ
                  โดยทีมพัฒนาของเราได้ปฏิบัติตามแนวทางการปฏิบัติที่ดีที่สุด
                  เพื่อให้มั่นใจว่าแอปพลิเคชั่นของลูกค้ามีความปลอดภัยจากภัยคุกคามและความเสี่ยงต่าง ๆ
                  ที่อาจเกิดขึ้นได้ มีความปลอดภัยด้านข้อมูลสูง
                </p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={<>และการบำรุงรักษาต่อเนื่อง</>}
              prologue='05.'
              subtitle='การช่วยเหลือ'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>
                  เราจะให้การช่วยเหลือและการบำรุงรักษาที่ต่อเนื่องเพื่อให้แน่ใจว่าแอปพลิเคชั่นมือถือของลูกค้ายังคงใช้งานได้ดี
                  อัปเดตได้ ทำงานได้ดีบนระบบปฏิบัติการและสามารถปรับแต่งให้มีประสิทธิภาพที่สูงได้
                </p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <div className='px-4'>
              <h3 className='mb-16 text-3xl'>Experiences</h3>
              <div className=''>
                <ListBullet
                  className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3'
                  list={[
                    'Radio Steaming App',
                    'VDO Streaming App',
                    'Music Steaming App',
                    'Loyalty App',
                    'E-Sport tournament App',
                    'E-Community App',
                    'E-Booking App',
                    'ETC.',
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-neutral py-28'>
        <div className='container mx-auto space-y-8 px-4'>
          <div className='grid grid-cols-1 items-center gap-4 text-white lg:grid-cols-2 xl:gap-8'>
            <ImgResponsive
              src='/images/service/service_contact.webp'
              alt='Twin Synergy service'
              sourceImgSm='/images/service/service_contact.webp'
              sourceImgMd='/images/service/service_contact.webp'
              loadingLazy
              className='mx-auto'
            />
            <div className='space-y-6'>
              <h2 className='xl:text-7xl'>
                เรามีทีมผู้เชี่ยวชาญใน
                <br />
                ด้านการพัฒนาและการออกแบบแอปพลิเคชั่น
              </h2>
              <p className='font-bold xl:text-4xl'>
                โดยเฉพาะคอยให้คำปรึกษาและคำแนะนำที่ดีให้กับคุณโปรดลงทะเบียนเพื่อส่งข้อมูลและรายละ
                <br />
                เดียดความต้องการของคุณคร่าว ๆ มาที่เรา
              </p>
              <p>เราจะจัดผู้เชี่ยวชาญในการให้ประสานกับคุณโดยเร็ว</p>
              <Button
                htmlType='button'
                className='btn-warning'
                onClick={() => Router.push('/contact')}
              >
                ลงทะเบียนขอคำปรึกษา
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className='pt-24 lg:pt-44'>
        <div className='container mx-auto space-y-8 px-4 pb-14 xl:pt-0'>
          <TitleShadow
            prologue='ผลงาน'
            colorPrologue='rgba(0,0,0,.08)'
            title={<>ผลงานของเรา</>}
            colorTitle='#000000'
            align='center'
          />
        </div>
        <div className='grid grid-cols-2 lg:grid-cols-4'>
          <PortfolioItem
            title='Atime.live'
            categories='Application'
            serviceImg='/images/service/mobile/mobile-atime.webp'
            serviceBg='#FFCA64'
          />
          <PortfolioItem
            title='EBA'
            categories='Application'
            serviceImg='/images/service/mobile/mobile-eba.webp'
            serviceBg='#FFCA64'
          />
          <PortfolioItem
            title='Kickdudes'
            categories='Application'
            serviceImg='/images/service/mobile/mobile_Kickdudes.webp'
            serviceBg='#FFCA64'
          />
          <PortfolioItem
            title='CDC'
            categories='Application'
            serviceImg='/images/service/mobile/mobile_CDC.webp'
            serviceBg='#FFCA64'
          />
        </div>
        <div className='bg-neutral text-center'>
          <Link
            className='flex items-center justify-center py-4 font-light text-white'
            href='/portfolio'
          >
            ดูโปรเจกต์ทั้งหมด <FaArrowRight className='ml-2' size={14} />
          </Link>
        </div>
        <div className='warranty grid grid-cols-2 lg:grid-cols-5'>
          <WarrantyItem
            content={
              <>
                Warrantee Source
                <br />
                code 1 year
              </>
            }
            serviceImg='/images/service/warratee.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Support team (8/7)
                <br />6 month
              </>
            }
            serviceImg='/images/service/support_team.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content='Free MA 6 month'
            serviceImg='/images/service/free_MA.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Free consultant
                <br />
                Forever
              </>
            }
            serviceImg='/images/service/free_consultant.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Free integration
                <br />
                service fee
              </>
            }
            serviceImg='/images/service/free_integration.webp'
            serviceBg='#F7F8F9'
          />
        </div>
      </div>
      <div className='bg-author-base py-24'>
        <div className='container mx-auto'>
          <ServiceGetInTouch content='"พวกเราคือทีมพัฒนามืออาชีพที่มีความเชี่ยวชาญและสามารถทำงานร่วมกับทุกคนได้อย่างมีประสิทธิภาพ"' />
        </div>
      </div>
      <div className='section-service pt-24 lg:pt-44'>
        <div className='container mx-auto space-y-8 px-4 pb-14 xl:pt-0'>
          <TitleShadow
            prologue='บริการ'
            colorPrologue='rgba(0,0,0,.08)'
            title='บริการอื่น ๆ'
            colorTitle='#000000'
            align='center'
          />
        </div>
        <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4'>
          <ServiceItem
            prologue='01'
            title='พัฒนาเว็บไซต์'
            serviceImg='/images/service/service-01.webp'
            serviceBg='#06B7B7'
            serviceUrl='website-development'
          />
          <ServiceItem
            prologue='02'
            title='พัฒนาแอปพลิเคชั่นมือถือ'
            serviceImg='/images/service/service-02.webp'
            serviceBg='#1990FF'
            serviceUrl='mobile-application-development'
          />
          <ServiceItem
            prologue='03'
            title='ออกแบบเว็บไซต์'
            serviceImg='/images/service/service-03.webp'
            serviceBg='#FFCA64'
            serviceUrl='website-design'
          />
          <ServiceItem
            prologue='04'
            title='เว็บไซต์สำหรับธุรกิจ SME'
            serviceImg='/images/service/service-04.webp'
            serviceBg='#FFAC79'
            serviceUrl='sme-website-development'
          />
          <ServiceItem
            prologue='05'
            title='ออกแบบและพัฒนา Line OA'
            serviceImg='/images/service/service-05.webp'
            serviceBg='#00BE00'
            serviceUrl='line-oa-development'
          />
          <ServiceItem
            prologue='06'
            title='พัฒนาซอฟต์แวร์ตามกำหนด'
            serviceImg='/images/service/service-06.webp'
            serviceBg='#FF7D7D'
            serviceUrl='custom-software-development'
          />
          <ServiceItem
            prologue='07'
            title='เพิ่มความปลอดภัย'
            serviceImg='/images/service/no-service.webp'
            serviceBg='#B577E5'
            noLink
          />
          <ServiceItem
            prologue='08'
            title='ดูแลบำรุงรักษาเว็บไซต์'
            serviceImg='/images/service/no-service.webp'
            serviceBg='#484848'
            noLink
          />
        </div>
      </div>
    </LayoutDefault>
  )
}

export default ServicePage
